import { useMemo } from "react";
import { BiRupee } from "react-icons/bi";

const ServiceabilityTable = ({
  columns,
  data = [],
  paymentMode = "",
  isService = false,
  isPercentage = true,
  isCurrency = false,
}) => {
  const filteredData = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  return (
    <div className="overflow-x-auto">
      <table
        className="w-full table-auto bg-background_2 rounded-xl border-secondary/20"
        aria-label="Serviceability Rates Table"
      >
        <thead>
          <tr className="bg-transparent text-backgroundL border-b-2 border-secondary/10">
            {columns.map((col, index) => (
              <th
                key={col}
                className={`text-subtitle1 min-w-44 font-nunito text-secondary/90 text-left px-4 py-2 ${
                  index === 0 ? "w-[40%]" : ""
                }`}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <TableRow
                key={item.id || `row-${index}`}
                item={item}
                paymentMode={paymentMode}
                isService={isService}
                isPercentage={isPercentage}
                isCurrency={isCurrency}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center text-headline5 font-nunito text-secondary/60 py-4"
              >
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const TableRow = ({
  item,
  paymentMode,
  isService,
  isPercentage,
  isCurrency,
}) => {
  const fields = useMemo(
    () => [
      { key: "courierName", label: "Courier Name" },
      ...(isService
        ? [
            { key: "surface", label: "Surface" },
            { key: "air", label: "Air" },
          ]
        : [
            {
              key: "shippingCharge",
              label: "Shipping Charge",
              isCurrency: true,
            },
            ...(paymentMode === "COD"
              ? [{ key: "codCharges", label: "COD Charges", isCurrency: true }]
              : []),
            {
              key: "gstCharges",
              label: "GST Charges",
              isCurrency: isCurrency,
              isPercentage: isPercentage,
            },
            { key: "totalCharge", label: "Total Charge", isCurrency: true },
          ]),
    ],
    [paymentMode],
  );

  return (
    <tr className="text-secondary border-b last:border-b-0 border-secondary/10">
      {fields.map(({ key, isCurrency, isPercentage }) => (
        <td
          key={key}
          className={`text-subtitle2 font-nunito text-secondary/80 text-left px-4 py-2 ${
            key === "courierName" ? "w-[40%]" : ""
          }`}
        >
          {isCurrency && <BiRupee className="inline-block mr-1" />}
          {item[key]}
          {isPercentage && "%"}
        </td>
      ))}
    </tr>
  );
};
export default ServiceabilityTable;
